<template>
    <div>
        <div class="columns toolbar-box">
            <div class="column is-2">
                <h1 class="title is-3 between-center">
                    <span>
                        <span>Proposals</span>
                        <a
                                v-if="! isView"
                                href="#"
                                class="gear"
                                @click.prevent="isTableSettingsModalActive = true"
                        >
                            <o-icon pack="fa" icon="gear" size="is-small"/>
                        </a>
                        <a
                                v-if="isView && currentTableView && canEditView(currentTableView.id)"
                                href="#"
                                class="gear"
                                @click.prevent="openCustomViewModal(currentTableView.id)"
                        >
                            <o-icon pack="fa" icon="edit" size="is-small"/>
                        </a>
                    </span>
                </h1>
            </div>
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <o-input
                            v-model="filters.number"
                            placeholder="Proposal #"
                            icon="search"
                            type="search"
                            @change.native="fetchPaginatedData(true)"
                    />
                </o-field>
            </div>
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <autocomplete-select
                            v-model="filters.contact_id"
                            placeholder="Contact"
                            type="contact"
                            :value="contactById(parseInt(filters.contact_id))"
                            field-name="full_name"
                            @update:modelValue="fetchPaginatedData(true)"
                    />
                </o-field>
            </div>
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <autocomplete-select
                            v-model="filters.company_id"
                            placeholder="Company"
                            type="company"
                            :value="companyById(parseInt(filters.company_id))"
                            field-name="name"
                            @update:modelValue="fetchPaginatedData(true)"
                    />
                </o-field>
            </div>
            <div class="column is-4 action-box">
                <div class="field is-grouped is-grouped-right">
                    <p class="control">
                        <a @click.prevent="openCustomViewModal(null)" class="button is-info"><span>Create Custom View</span></a>
                    </p>
                    <p v-if="isResetFiltersButtonVisible" class="control">
                        <a @click.prevent="resetFilters" class="button is-info"><span>Reset filters</span></a>
                    </p>
                    <p v-if="isDeleteSelectedButtonVisible" class="control">
                        <a @click.prevent="confirmCustomDelete" class="button is-danger"><span>Delete selected</span></a>
                    </p>
                    <p class="control">
                        <router-link :to="{ name: 'proposals.create' }" class="button is-info" ><span class="icon"><i class="icm-new"></i></span><span>New</span></router-link>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns toolbar-box action-right">
            <div class="column is-2"></div>
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <o-input
                            v-model="filters.address"
                            type="search"
                            placeholder="Address"
                            icon="search"
                            @change.native="fetchPaginatedData(true)"
                    />
                </o-field>
            </div>
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <autocomplete-select
                            v-model="filters.created_by"
                            placeholder="Creator"
                            type="user"
                            field-name="full_name"
                            :value="userById(parseInt(filters.created_by))"
                            @update:modelValue="fetchPaginatedData(true)"
                    />
                </o-field>
            </div>
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <o-select
                            v-model="filters.status"
                            :expanded="true"
                            placeholder="Proposal Status"
                            @update:modelValue="fetchPaginatedData(true)"
                    >
                        <option value="">Select Status</option>
                        <option
                            v-for="(status, key) in proposalStatuses"
                            :key="key"
                            :value="status.id"
                        >
                            {{ status.name }}
                        </option>
                    </o-select>
                </o-field>
            </div>
        </div>
        <custom-views-filter
                :view-id-prop="filters.table_view_id"
                type="proposals"
                @input="changeCustomView"
        />

        <o-table
            class="fullwidth-table is-responsive is-responsive-xs-desktop"

            v-if="isTableVisible"
            :data="paginatedData"

            :bordered="table.bordered"
            :striped="table.striped"
            :narrowed="table.narrowed"
            :checkable="table.checkable"
            :mobile-cards="table.mobileCards"
            :paginated="table.paginated"
            :pagination-simple="table.paginationSimple"
            :per-page="table.perPage"
            :default-sort-direction="table.defaultSortDirection"
            :default-sort="table.defaultSort"

            :selected.sync="selected"
            :checked-rows="checkedRows"
            @update:checkedRows="$event => checkedRows = $event"

            :loading="loading"
            :total="total"
            backend-sorting
            backend-pagination
            @page-change="onPageChange"
            @sort="onSort"
        >
            <template>
                <template>
                    <o-table-column
                        :label="col.field === 'actions' ? '' : col.label"
                        v-for="col in customViewTableColumns"
                        #default="{ row }"
                    >
                        <proposal-column v-if="col.field !== 'actions'" :field="col.field" :item="row" />

                        <o-dropdown aria-role="list" v-if="col.field === 'actions'" :triggers="['hover']" position="bottom-left" class="table-actions">
                            <template class="button" #trigger="{ active }">
                                <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                            </template>

                            <o-dropdown-item  aria-role="listitem">
                              <router-link :to="{ name: 'proposals.show', params: { slug: row.id } }">View</router-link>
                            </o-dropdown-item>
                            <o-dropdown-item  aria-role="listitem">
                              <router-link :to="{ name: 'proposals.clone', params: { slug: row.id } }">Clone Proposal</router-link>
                            </o-dropdown-item>
                            <o-dropdown-item  aria-role="listitem"  v-if="row.project_id">
                              <router-link :to="`/projects/${row.project_id}`">View Project</router-link>
                            </o-dropdown-item>
                            <o-dropdown-item  aria-role="listitem">
                              <a :href="`/proposals/${row.id}/pdf`" @click.prevent.stop="openPreviewModal(row)">Preview PDF</a>
                            </o-dropdown-item>
                            <o-dropdown-item  aria-role="listitem"  v-if="!row.project_id" has-link>
                              <a @click="openMessageModal({entity: row, entity_type: 'proposal', context: 'proposal-request-signature-message'})">Send to Customer</a>
                            </o-dropdown-item>
                            <o-dropdown-item  aria-role="listitem">
                              <a @click="openReminderModal(row.id)">Set Reminder</a>
                            </o-dropdown-item>
                            <o-dropdown-item  aria-role="listitem">
                              <a @click="openMessageModal({entity: row, entity_type: 'proposal', context: 'proposal-reminder-message', isReminder: true})">Send Reminder to Customer</a>
                            </o-dropdown-item>
                            <o-dropdown-item  aria-role="listitem"  v-if="!row.project_id">
                              <a @click.stop.prevent="convertToProject(row)">Convert To Project</a>
                            </o-dropdown-item>
                        </o-dropdown>
                    </o-table-column>

                </template>
            </template>

            <template v-slot:empty>
                <div class="has-text-centered">
                  This table is empty!
                </div>
            </template>
        </o-table>

        <total
                :is-filtered="isResetFiltersButtonVisible"
                :total-amount="proposalsTotal"
                :filtered-amount="total"
        />

        <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isReminderModalActive" has-modal-card>
            <reminder-modal :reference-id="proposalId" reference-type="proposal"/>
        </o-modal>

        <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isPreviewModalActive" :trap-focus="true" class="preview-modal" has-modal-card>
            <preview-modal :file="currentPreviewFile"/>
        </o-modal>

        <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName"/>
        </o-modal>

        <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isCustomViewModalActive" has-modal-card>
            <custom-view-modal
                    :custom-view="customViewToEdit"
                    type="proposals"
                    @custom-view-created="filters.table_view_id = $event"
                    @custom-view-deleted="filters.table_view_id = null"
            />
        </o-modal>
    </div>
</template>

<script>
    import ProposalColumn from './../../components/table-columns/Proposal'
    import SupportsCustomViews from './../../mixins/SupportsCustomViews'
    import PreviewModal from './../../components/modals/Preview'
    import { mapActions, mapGetters } from 'vuex'
    import Total from './../../components/Total'
    import Table from '../../mixins/Table'
    import "../../filters"
    import {contactById} from "../../store/getters/contacts";
    import {companyById} from "../../store/getters/companies";

    export default {
        components: { PreviewModal, ProposalColumn, Total },

        mixins: [Table, SupportsCustomViews],

        data () {
            return {
                isReminderModalActive: false,
                tableName: 'proposals-index',
                isPreviewModalActive: false,
                currentPreviewFile: null,
                currentProposal: null,
                proposalId: null
            }
        },

        computed: {
            ...mapGetters({
                proposalStatuses: 'proposalStatuses',
                itemsByIds: 'proposalsByIds',
                proposalsTotal: 'proposalsTotal'
            }),

            ...mapGetters([
                'proposalStatuses', 'proposalsByIds', 'userById', 'companyById', 'contactById'
            ]),
        },

        created () {
            this.filters = {
                proposal_id: '',
                company_id: '',
                contact_id: '',
                created_by: '',
                address: '',
                status: '',
                table_view_id: null
            }
        },

        mounted () {
            this.fetchPaginatedData()
        },

        watch:{
          'filters.company_id'(value){
            this.fetchCompanies({ id: value })
          },
          'filters.contact_id'(value){
            this.fetchContacts({ id: value })
          },
        },

        methods: {
          companyById,
          contactById,
            ...mapActions({
                removeItem: 'removeProposal',
                fetchData: 'fetchProposals'
            }),

            ...mapActions([
                'openMessageModal',
                'convertProposal',
                'fetchCompanies',
                'fetchContacts',
                'fetchUsers'
            ]),

            convertToProject (proposal) {
                this.convertProposal(proposal)
                    .then(res => {
                        this.successMessage('Proposal was successfully converted to a project')
                        return res
                    })
            },

            openPreviewModal(proposal) {
                const port = window.location.port ? `:${window.location.port}` : '';
                this.currentPreviewFile = {
                    name: `Proposal #${proposal.number}`,
                    mime: 'application/pdf',
                    path: `${window.location.protocol}//${window.location.hostname}${port}/proposals/${proposal.id}/pdf`,
                    generatedOnTheFly: true
                }
                this.isPreviewModalActive = true
            },

            openReminderModal (proposalId) {
                this.isReminderModalActive = true
                this.proposalId = proposalId
            }
        }
    }
</script>
<style>
.media {
  align-items: flex-start;
  display: flex;
  text-align: left;
}
.media-content {
  flex-basis: auto;
  flex-grow: 1;
  flex-shrink: 1;
  text-align: left;
  overflow-y: hidden;
  overflow-x: auto;
}
.media-left {
  margin-right: 1rem;
  flex-basis: auto;
  flex-grow: 0;
  flex-shrink: 0;
}
</style>
